const PropertyDynamicAttributes = ({ items = [], className = "", columns = 2 }) => {
  if (!items.length) {
    return null;
  }

  return (
    <dl
      className={`property-detail-attributes property-detail-attributes--cols-${columns} ${className}`.trim()}
    >
      {items.map((item) => (
        <div key={item.key} className="property-detail-attributes__item">
          <dt>{item.label}</dt>
          <dd>
            {item.values ? (
              <span className="property-detail-attributes__tags">
                {item.values.map((tag) => (
                  <span key={tag} className="property-detail-pill">
                    {tag}
                  </span>
                ))}
              </span>
            ) : (
              item.formatted
            )}
          </dd>
        </div>
      ))}
    </dl>
  );
};

export default PropertyDynamicAttributes;
